import isEqual from 'lodash.isequal';

export function wait(data: any, time: number): Promise<any> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data);
    }, time);
  });
}

export function asyncRecursive(func: Function, time: number): any {
  let timerId: number | undefined;
  let isTimerCanceled: boolean = false;

  return {
    async run(...args: any[]) {
      try {
        await func(...args);
      } catch (e) {

      }

      timerId = setTimeout(timeout, time, ...args);
    },
    cancel() {
      isTimerCanceled = true;

      clearTimeout(timerId);
    }
  };

  async function timeout(...args: any[]) {
    try {
      await func(...args);
    } catch (e) {

    }

    if (!isTimerCanceled) {
      timerId = setTimeout(timeout, time, ...args);
    }
  }
}

export function getObjectsDiff(editedObject: any, originalObject: any): Readonly<any> | undefined {
  const editedFields: any = {};
  let editedField: any;

  for (let field in editedObject) {
    if (editedObject.hasOwnProperty(field)) {
      editedField = differenceDeep(editedObject[field], originalObject[field]);

      if (editedField || (editedField === editedObject[field] && editedObject[field] !== originalObject[field])) {
        editedFields[field] = editedField;
      }

      editedField = undefined;
    }
  }

  if (Object.values(editedFields).length > 0) {
    return Object.freeze(editedFields);
  }
}

export function getArrayDiff(editedArray: Array<any>, originalArray: Array<any>): ReadonlyArray<any> | undefined {
  const editedItems: Array<any> = [];
  let editedItem: any;

  for (let i = 0; i < editedArray.length; i++) {
    editedItem = differenceDeep(editedArray[i], originalArray[i]);

    if (editedItem || (editedItem === editedArray[i] && editedArray[i] !== originalArray[i])) {
      editedItems[i] = editedItem;
    }
  }

  if (editedItems.length > 0) {
    return Object.freeze(editedItems);
  }
}

export function differenceDeep(editedValue: any, originalValue: any): any {
  if (editedValue instanceof Object) {
    switch (editedValue.constructor.name) {
      case 'Date': {
        if (isDifferentDates(editedValue, originalValue)) {
          return editedValue;
        }

        break;
      }

      case 'Array': {
        return getArrayDiff(editedValue, originalValue);
      }

      case 'Object': {
        return getObjectsDiff(editedValue, originalValue);
      }

      default: {
        return getObjectsDiff(editedValue, originalValue);
      }
    }
  } else if (editedValue !== originalValue) {
    return editedValue;
  }
}

export function difference(editedValue: any, originalValue: any) {
  if (editedValue instanceof Object) {
    const editedFields: any = {};

    for (let key in editedValue) {
      if (editedValue.hasOwnProperty(key) && !isEqual(originalValue[key], editedValue[key])) {
        editedFields[key] = editedValue[key];
      }
    }

    return editedFields;
  } else if (editedValue !== originalValue) {
    return editedValue;
  }
}

export function isDifferentDates(...dates: Array<Date>): boolean {
  return new Set(
    dates.map((date: Date) => date.getTime())
  ).size === dates.length;
}

export function generateActualOrdersForDayStructure() {
  return Array.apply(null, new Array(24)).map(generateActualOrdersForHourStructure);
}

export function generateActualOrdersForHourStructure() {
  return Array.apply(null, new Array(12)).map(() => []);
}

export function getNextSibling(elem?: Element | null, selector: string = '') {
  if (elem && selector) {
    let sibling = elem.nextElementSibling;

    while (sibling) {
      if (sibling.matches(selector)) {
        return sibling;
      }

      sibling = sibling.nextElementSibling;
    }
  }

  return null;
}
